import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.$style.top
  }, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 4 }),
        _createVNode(_component_el_col, { span: 16 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 3 }, {
                      default: _withCtx(() => [
                        _createTextVNode("タイトル")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 21 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          onInput: _ctx.changed,
                          onChange: _ctx.changed
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.state.videoDataRaw.value,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.videoDataRaw.value) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["onInput", "onChange"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 3 }, {
                      default: _withCtx(() => [
                        _createTextVNode("説明")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 21 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          onInput: _ctx.changed,
                          onChange: _ctx.changed
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "textarea",
                              rows: 10,
                              modelValue: _ctx.state.videoDataRaw.description,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.videoDataRaw.description) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["onInput", "onChange"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 3 }, {
                      default: _withCtx(() => [
                        _createTextVNode("公開リンク")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 21 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          onInput: _ctx.changed,
                          onChange: _ctx.changed
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "text",
                              modelValue: _ctx.state.videoDataRaw.videoViewSrc,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.videoDataRaw.videoViewSrc) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["onInput", "onChange"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("p", {
                      id: _ctx.$style.link_caution
                    }, [
                      _createTextVNode(" 公開リンクはURLの末尾になります。"),
                      _hoisted_3,
                      _createTextVNode(" アルファベットで端的に、他と被らないように記述して下さい。 ")
                    ], 8, _hoisted_2)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 4 })
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.input_area)
    }, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 3 }, {
            default: _withCtx(() => [
              _createTextVNode(" プラン選択 ")
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 21,
            class: _normalizeClass(_ctx.$style.input_checkbox_area)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, {
                class: _normalizeClass(_ctx.$style.input)
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stripePlanList, (plan) => {
                    return (_openBlock(), _createBlock(_component_el_col, {
                      span: 8,
                      key: plan.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(plan.title) + " ", 1),
                        _createVNode(_component_el_checkbox, {
                          onChange: _ctx.changed,
                          modelValue: _ctx.state.selectPlan[Number(plan.id)],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.state.selectPlan[Number(plan.id)]) = $event)
                        }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      })
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.input_area)
    }, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 3 }, {
            default: _withCtx(() => [
              _createTextVNode(" コース選択 ")
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 21,
            class: _normalizeClass(_ctx.$style.input_checkbox_area)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.state.videoDataRaw.courseId,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.videoDataRaw.courseId) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseList, (course) => {
                    return (_openBlock(), _createBlock(_component_el_radio, {
                      onChange: _ctx.changed,
                      key: course.id,
                      label: course.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(course.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["onChange", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      })
    ], 2),
    _createElementVNode("div", null, [
      _createTextVNode(" 非公開 "),
      _createVNode(_component_el_switch, {
        onChange: _ctx.changed,
        modelValue: _ctx.state.videoDataRaw.release,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.videoDataRaw.release) = $event)),
        style: {"--el-switch-on-color":"#6da84f"}
      }, null, 8, ["onChange", "modelValue"]),
      _createTextVNode(" 公開 ")
    ])
  ], 8, _hoisted_1))
}